import React, { useEffect, useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";

const ReCAPTCHAComponent = () => {
    const recaptchaRef = useRef<ReCAPTCHA | null>(null);
    useEffect(() => {
        if (recaptchaRef.current) recaptchaRef.current.executeAsync().catch(err => {
                console.error("ReCAPTCHA execution failed:", err);
            });
    }, []);

    return (
        <>
            <style>
                {`.grecaptcha-badge {   
                    bottom: 90px !important;
                    z-index: 9999999999 !important;
                }`}
            </style>
            <ReCAPTCHA
                className="invisible"
                ref={recaptchaRef}
                size="invisible"
                sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY as string}
            />
        </>
    );
};

export default ReCAPTCHAComponent;
